import * as api from './data-analyze-api'
import { deepCopy, thousands } from '@/untils/untils.js'
import { mapState, mapMutations } from 'vuex'
import Pie from '@/components/echarts/pie.vue'
import Bar from '@/components/echarts/bar-analyze.vue'
export default {
    components: {
        Pie, Bar
    },
    beforeRouteEnter(to, from, next) {
        console.log(from);
        next((vm) => {
            console.log(vm);
            let { query: { queryInfo, toggleSwitch } } = from
            if (from.path == '/project' && queryInfo) {
                vm.queryInfo = JSON.parse(queryInfo)
                vm.toggleSwitch = toggleSwitch ? toggleSwitch : 'bar'
            }
        })
    },
    data() {
        return {
            thousands,
            // header
            // header
            isMobileFlag: JSON.parse(localStorage.getItem('isMobileFlag')),
            // table
            tableData: [],
            pageSize: 10,
            currPage: 1,
            total: 0,
            /* 修改flag */
            editFlag: false,
            supplierList: [],            //供应商列表
            /* supplierType */
            SupplierTypeList: [],

            /* supplierNature */
            SupplierNatureList: [],

            /* supplierNature */
            SupplierBrandList: [],
            statisticsInfo: {},          //供应商统计信息
            /* 搜索信息 */
            queryInfo: {
                tsId: '',
                time: '',
                startDate: '',
                endDate: '',
                tsBrandList: [],
                tsNatureList: [],
                tsTagList: [],
            },
            toggleSwitch: 'bar',
            /* 饼图数据 */
            bidProjectData: {
                datas: [],
                axisData: []
            },                            //中标项目
            bidCostData: {
                datas: [],
                axisData: []
            },                            //中标金额
            bidProjectCardData: [],       //排行数据
            bidCostCarddData: [],
            countData: {},
            changeProject: false,
            chartType: 'bar',
        }
    },
    async mounted() {
        this.findSupplierList()
        this.findSupplierTypeTag()
        this.findSupplierNature()
        this.findSupplierBrand()
        this.findStatisticsGroupByDate(this.queryInfo)
    },
    watch: {
        'queryInfo.time': {
            deep: true,
            handler(val) {
                this.queryInfo.startDate = val ? val[0] : null
                this.queryInfo.endDate = val ? val[1] : null
            }
        },
        pageSize(val) {
            if (val) {
                this.currPage = 1
                if (this.queryInfo.tsId.length) return
                this.findStatisticsGroupByDate(this.queryInfo)
            }
        },
        toggleSwitch(val) {
            console.log(this.pageNo);
            if (val !== 'table') {
                this.chartType = val
            }
            this.findStatisticsGroupByDate(this.queryInfo)
        },

    },
    computed: {
        ...mapState({
            pageNo: s => s.pageNo
        })
    },

    methods: {
        ...mapMutations(['CHANGE_PAGE_NO']),
        /* 查询供应商 */
        findSupplierList() {
            api.findSupplierList({}).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.supplierList = d

                }
            })
        },

        /* 查询供应商类别标签 */
        findSupplierTypeTag(findType) {
            api.findSupplierTypeTag({
                findType
            }).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.SupplierTypeList = d
                }
            })
        },

        /* 查询供应商性质标签 */
        findSupplierNature(findType) {
            api.findSupplierNature({
                findType
            }).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.SupplierNatureList = d
                }
            })
        },

        /* 查询供应商品牌标签 */
        findSupplierBrand(findType) {
            api.findSupplierBrand({
                findType
            }).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.SupplierBrandList = d
                }
            })
        },

        /* 供应商统计 */
        findStatisticsGroupByDate(query) {
            this.clearData()
            let {
                pageSize,
                currPage
            } = this
            let { tsId, startDate, endDate, tsBrandList, tsNatureList, tsTagList } = this.queryInfo
            let apis = []
            let tableDatas = []
            let chartDatas = []
            console.log(tsId);
            if (tsId.length) {
                this.currPage = 1
                this.pageSize = 9999
                tsId.map(t => {
                    apis.push(api.findStatisticsGroupByDate({
                        pageSize,
                        currPage,
                        startDate,
                        endDate,
                        tsId: t,
                        tsTagList,
                        tsNatureList,
                        tsBrandList
                    }))
                })
                Promise.all(apis).then(result => {
                    result.map(t => {
                        let d = t.data.resultObject
                        this.countData = d.count
                        this.total += d.tableDatas?.totalCount
                        tableDatas = [...tableDatas, ...d.tableDatas?.dataList]
                        chartDatas = [...d.chartDatas, ...chartDatas]
                    })
                    this.handleChartData(tableDatas, chartDatas)
                })
            } else {
                this.pageSize = 10
                api.findStatisticsGroupByDate({
                    pageSize,
                    currPage,
                    startDate,
                    endDate,
                    tsId: "",
                    tsTagList,
                    tsNatureList,
                    tsBrandList
                }).then(result => {
                    console.log(result);
                    if (result) {
                        let d = result.data.resultObject
                        this.countData = d.count
                        this.total = d.tableDatas?.totalCount
                        tableDatas = d.tableDatas?.dataList
                        chartDatas = d.chartDatas
                        this.handleChartData(tableDatas, chartDatas)
                    }
                })
            }


        },

        handleChartData(tableDatas, chartDatas) {
            this.tableData = tableDatas.map(t => {
                Object.keys(t).forEach(key => {
                    let val = t[key]
                    t[key] = val ? val : 0
                })
                let {
                    totalNum,
                    biddingTotalNum,
                    totalAmount,
                    biddingTotalAmount,
                    tsName } = t
                t.percent = (biddingTotalNum / totalNum * 100)?.toFixed(2)
                return t
            })
            /* 图标数据处理 */
            chartDatas.map(t => {
                let {
                    totalNum,
                    biddingTotalNum,
                    totalAmount,
                    biddingTotalAmount,
                    tsName,
                    tsId
                } = t

                if (biddingTotalNum > 0) {
                    this.bidProjectData.datas.push({ name: tsName, value: biddingTotalNum, tsId })
                    this.bidProjectData.axisData.push(tsName)
                }
                if (biddingTotalAmount > 0) {
                    biddingTotalAmount = (+biddingTotalAmount).toFixed(0)
                    this.bidCostData.datas.push({ name: tsName, value: biddingTotalAmount, tsId })
                    this.bidCostData.axisData.push(tsName)
                }
                this.bidProjectCardData = deepCopy(this.bidProjectData?.datas).sort(function (a, b) {
                    return b.value - a.value
                })
                this.bidProjectCardData = this.bidProjectCardData.map(t => {
                    t.value = thousands(t.value)
                    return t

                })
                this.bidCostCarddData = deepCopy(this.bidCostData?.datas).sort(function (a, b) {
                    return b.value - a.value
                })
                this.bidCostCarddData = this.bidCostCarddData.map(t => {
                    t.value = thousands(t.value)
                    return t
                })
            })
        },

        /* handle */
        pieClick(param) {
            console.log(param);
            let { data: { tsId } } = param
            this.$router.push({
                path: "/project",
                query: {
                    tsId,
                    queryInfo: JSON.stringify(this.queryInfo),
                    toggleSwitch: this.toggleSwitch
                }
            })
            this.CHANGE_PAGE_NO('{menuMuid: 1, menuName: 项目管理}')
        },
        rankItemClick(param) {
            console.log(1);
            let { tsId } = param
            this.$router.push({
                path: "/project",
                query: {
                    tsId,
                    queryInfo: JSON.stringify(this.queryInfo),
                    toggleSwitch: this.toggleSwitch
                }
            })
            this.CHANGE_PAGE_NO('{menuMuid: 1, menuName: 项目管理}')

        },
        clearData() {
            this.tableData = []
            this.bidCostCarddData = []
            this.bidProjectCardData = []
            this.bidProjectData = {
                datas: [],
                axisData: []
            }
            this.bidCostData = {
                datas: [],
                axisData: []
            }
        },
        setRankIconStyle(i) {
            let className
            switch (i) {
                case 0:
                    className = '#icondiyiming1'
                    break;
                case 1:
                    className = '#icondierming1'
                    break;
                case 2:
                    className = '#icondisanming1'
                    break;

                default:
                    break;
            }
            return className
        },

        /* table */
        // 排序
        totalNumSort(a, b) {
            return a.totalNum - b.totalNum
        },
        biddingTotalNumSort(a, b) {
            return a.biddingTotalNum - b.biddingTotalNum

        },
        totalAmountSort(a, b) {
            return a.totalAmount - b.totalAmount

        },
        biddingTotalAmountSort(a, b) {
            return a.biddingTotalAmount - b.biddingTotalAmount
        },
        percentSort(a, b) {
            console.log(a.percent, b.percent);
            return a.percent - b.percent
        },
        // 索引
        indexMethod(index) {
            return (this.currPage - 1) * this.pageSize + index + 1
        },
        handleCurPageChange(val) {
            this.currPage = val
            if (this.queryInfo.tsId.length) return
            this.findStatisticsGroupByDate(this.queryInfo)
        },
        /* 关键词搜索 */
        queryInfoByKeyword() {
            this.findStatisticsGroupByDate(this.queryInfo)
        },
    },
}